export interface AnimationReady {
    animationReady: AnimationStatus
}
export type AnimationStatus = 0 | 1 | 2
export const animationKeys: {[key: string]: AnimationStatus} = {
    'none': 0,
    'loading': 1,
    'loaded': 2
}